"use client";

import { motion } from "framer-motion";
import { Icon } from "@/components/ui/Icon";
import type { Locale } from "@/config/i18n";
import { tr } from "@/config/localeText";
import { LANDING, href } from "./landingDict";

type AboutSectionProps = {
  className?: string;
  locale?: Locale;
};

export const AboutSection = ({
  className,
  locale = "fr",
}: AboutSectionProps) => {
  const t = tr(LANDING, locale).about;
  return (
    <section
      className={
        "relative w-full bg-white py-28 text-black " + (className ?? "")
      }
    >
      <div className="mx-auto max-w-7xl px-4">
        <motion.h2
          initial={false}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          viewport={{ once: true, margin: "-10%" }}
          className="mb-4 text-center font-space-age text-2xl tracking-[0.25em] text-black"
        >
          {t.heading}
        </motion.h2>
        <p className="mx-auto mb-8 max-w-3xl text-center text-black/80">
          {t.intro}
        </p>
        <div className="mb-8 text-center">
          <a
            href={href(locale, "/a-propos")}
            className="inline-flex items-center gap-2 rounded-lg border border-black/15 px-5 py-2.5 text-sm font-medium text-black transition-colors hover:border-primary"
          >
            {t.cta}
          </a>
        </div>
        <div className="grid gap-6 md:grid-cols-3">
          {t.items.map((item) => (
            <motion.div
              key={item.title}
              initial={false}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true, margin: "-15%" }}
              className="rounded-2xl border border-neutral-700 bg-transparent p-6 text-black"
            >
              <div className="mb-3 flex items-center gap-3">
                <Icon icon={item.icon} className="h-6 w-6 text-primary" />
                <h3 className="text-lg font-semibold">{item.title}</h3>
              </div>
              <p className="text-sm text-black/70">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
